<template>
  <div>
    <breadcrumbs></breadcrumbs>
    <div class="ind-title lh50 f16">
      <!-- <i class="el-icon-loading"></i> -->
      在职业务员详情
    </div>

    <div class="oid" v-if="ob == 1">
      <el-form label-width="100px" class="demo-ruleForm">
        <el-form-item label="名称">
          <el-input :disabled="true" v-model="info.saleName"></el-input>
        </el-form-item>

        <el-form-item label="性别">
          <el-radio-group :disabled="true" v-model="info.sex">
            <el-radio label="1">男</el-radio>
            <el-radio label="2">女</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item label="身份证号">
          <el-input :disabled="true" v-model="info.idcard"></el-input>
        </el-form-item>

        <el-form-item label="手机号">
          <el-input :disabled="true" v-model="info.phone"></el-input>
        </el-form-item>

        <el-form-item label="联系地址">
          <el-input :disabled="true" v-model="info.address"></el-input>
        </el-form-item>

        <el-form-item label="入职时间">
          <el-input :disabled="true" v-model="info.addtime"></el-input>
        </el-form-item>
        <!-- 
        <el-form-item label="职位">
          <el-input :disabled="true" v-model="info.jobId"></el-input>
        </el-form-item> -->

        <el-form-item label="职位">
          <!-- <el-input v-model="form.jobId" placeholder="请输入职位"></el-input> -->

          <el-select
            :disabled="true"
            v-model="info.jobId"
            placeholder="请输入职位"
          >
            <el-option
              v-for="item in odjobId"
              :key="item.jobId"
              :label="item.jobName"
              :value="item.jobId"
            >
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="业务区域" prop="cityDetailId">

           <el-input :disabled="true" v-model="addywxq"></el-input>
       
        </el-form-item>

        <!-- <el-form-item label="业务区域">
          <el-input :disabled="true" v-model="info.cityIds"></el-input>
        </el-form-item> -->
      </el-form>
    </div>

    <div class="oid" v-if="ob == 2">
      <el-form label-width="100px" class="demo-ruleForm">
        <el-form-item label="名称">
          <el-input v-model="info.saleName"></el-input>
        </el-form-item>

        <el-form-item label="性别">
          <el-radio-group v-model="info.sex">
            <el-radio label="1">男</el-radio>
            <el-radio label="2">女</el-radio>
          </el-radio-group>

          <!-- <el-select :disabled="true" v-model="info.sex" placeholder="性别">
            <el-option label="男" value="1"></el-option>
            <el-option label="女" value="2"></el-option>
          </el-select> -->
        </el-form-item>

        <el-form-item label="身份证号">
          <el-input v-model="info.idcard"></el-input>
        </el-form-item>

        <el-form-item label="手机号">
          <el-input v-model="info.phone"></el-input>
        </el-form-item>

        <el-form-item label="联系地址">
          <el-input v-model="info.address"></el-input>
        </el-form-item>

        <el-form-item label="入职时间">
          <el-input v-model="info.addtime"></el-input>
        </el-form-item>

        <el-form-item label="职位">
          <!-- <el-input v-model="form.jobId" placeholder="请输入职位"></el-input> -->

          <el-select v-model="info.jobId" placeholder="请输入职位">
            <el-option
              v-for="item in odjobId"
              :key="item.jobId"
              :label="item.jobName"
              :value="item.jobId"
            >
            </el-option>
          </el-select>
        </el-form-item>




          <el-form-item label="业务区域" prop="cityDetailId"  v-if="shodd">

           <el-input  v-model="addywxq"  @focus="getgondd"></el-input>
       
        </el-form-item>




        <el-form-item label="业务区域" prop="cityDetailId"   v-if="disaa" >
          <el-cascader
            :props="optionProps"
            v-model="info.cityIds"
            :options="city"
            @change="handleChange"
            clearable
          ></el-cascader>
        </el-form-item>














      </el-form>
    </div>

    <el-button type="primary" @click="getzhuanyi">转移</el-button>

    <div class="ind-title lh50 f16">
      <!-- <i class="el-icon-loading"></i> -->
      绑定回收站
    </div>

    <el-table
      :data="tableData"
      style="width: 100%"
      :header-cell-style="{ background: '#eef1f6', color: '#606266' }"
    >
      <el-table-column label="序号" prop="index" type="index">
      </el-table-column>

      <el-table-column label="类型" prop="planCount"> </el-table-column>

      <el-table-column label="回收站名称" prop="stopName"> </el-table-column>

      <el-table-column label="直推人" prop="nickName"> </el-table-column>
    </el-table>

    <!-- <div class="shanc" v-if="ob == 1">
      <el-button>返回</el-button>
      <el-button type="primary">导出</el-button>
    </div> -->

    <div class="shanc" v-if="ob == 2">
      <el-button @click="getqdxigai">确定修改</el-button>
    </div>

    <el-dialog
      title="转移回收站"
      :visible.sync="addORUpdateVisible1"
      width="500px"
      @close="getshenhei"
    >
      <el-form
        :model="userForm1"
        label-width="120px"
       
      
      >
        <el-form-item label="选择回收站" prop="roleId">
          <el-select
            v-model="userForm1.backStopIds"
            placeholder="请选择用户角色"
          >
            <el-option
              :label="v.stopName"
              :value="v.backStopId"
              v-for="(v, i) in tableData"
              :key="i"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="转移至" prop="roleId">
          <el-select v-model="userForm1.saleId" placeholder="请选择用户角色">
            <el-option
              :label="v.saleName"
              :value="v.saleId"
              v-for="(v, i) in saleList"
              :key="i"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click.native="addORUpdateVisible2 = false">取消</el-button>
        <el-button type="primary" @click.native="getabbing">提交</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import options from "../../../city.json";
import breadcrumbs from "@/components/breadcrumbs.vue";

export default {
  components: {
    breadcrumbs,
  },
  data() {
    return {

      shodd:true,
      disaa:false,

  
      addywxq:"",
      userForm1: {
        backStopIds: "",
        saleId: "",
      },
      addORUpdateVisible1: false,
      odjobId: [],
      regionId: [],
      city: [],
      optionProps: {
        value: "regionId",
        label: "regionName",
        children: "child",
      },

      ob: this.$route.query.ob,
      backStopList: [],
      tableData: [],
      saleList: [],
      info: {
        // name: "",
        // region: "",

        address: "",
        addtime: "",

        cityIds: "",

        idcard: "",
        saleId: this.$route.query.id,
        jobId: "",
        phone: "",

        saleName: "",

        sex: "1",
      },
    };
  },

  created() {
    this.city = options;
    console.log(options);
    this.getSaleDetail();
    this.getAllJobList();

    this.getzhaizhi();
  },

  methods: {

      getgondd(){

           this.shodd=false,
              this.disaa=true


      },
 



    getshenhei() {},

    getabbing() {
      this.$api.activitymsg.changeBackStopToSale(this.userForm1).then((e) => {
        if (e.code == 200) {
          (this.userForm1 = {}), this.$message.success("转移成功");
          this.addORUpdateVisible1 = false;
        } else {
          this.$message.error(d.msg);
        }
      });
    },

    getzhuanyi() {
      this.addORUpdateVisible1 = true;
    },

    handleChange(value) {
      console.log(value);
      this.info.cityIds = value[2];
    },

    getzhaizhi() {
      this.$api.activitymsg.getAddBackStopForm({}).then((e) => {
        this.saleList = e.data.saleList;
      });
    },

    getAllJobList() {
      this.$api.activitymsg.getAllJobList({}).then((e) => {
        this.odjobId = e.data;
      });
    },

    getqdxigai() {
      this.$api.activitymsg.editSale(this.info).then((e) => {
        if (e.code == 200) {
          this.$message({
            message: "操作成功",
            type: "success",
          });

          this.$router.push("/business/index");
        } else {
          this.$message.error(e.msg);
        }
      });
    },

    getSaleDetail() {
      this.$api.activitymsg
        .getSaleDetail({
          saleId: this.$route.query.id,
        })
        .then((e) => {




       


          // this.city.map((item1) => {
          //   item1.child.map((item2) => {
          //     item2.child.map((item3) => {
          //       e.data.cityList.mpa((itedd) => {
          //         if (item3.regionId == itedd.cityId) {

          //            this.addywxq=item3.regionName

          //         }
          //       });
          //     });
          //   });
          // });

          this.tableData = e.data.backStopList;

          var info = e.data.info;

          info.sex = info.sex + "";

          this.info = info;
          console.log(e.data.cityList,"1234567");
         
          e.data.cityList.map(item =>{

               this.city.map(item1 => {

                   item1.child.map(item2=>{

                        item2.child.map(item3=>{

                              if (item3.regionId == item.cityId) {
                                   console.log("123");

                                   this.addywxq=item3.regionName

                              }

                        })




                      
                   })

               })


           



       
    })

















        });
    },
  },
};
</script>

<style scoped>
.shanc {
  display: flex;
  justify-content: center;
  align-items: center;
}

.oid {
  width: 40%;
}
</style>
